export default "__VITE_ASSET__DpZIyxGu__"